

import { makeStyles } from 'tss-react/mui';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import { Box, ContentTemplate, Tabs } from 'web-library';
import { candidateService } from '../../../api';
import TransactionHistory from '../../subject/components/TransactionHistory';
import ExamRegistrationsListingTablesDialog from './ExamRegistrationsListingTablesDialog';

// TODO jss-to-tss-react codemod: usages of this hook outside of this file will not be converted.
export const useStyles = makeStyles()((theme) =>
({
  table: {
    marginBottom: theme.spacing(3),
  },
  tabsHeader: {
    '& .MuiTab-root': {
      textTransform: 'none',
    },
    marginBottom: theme.spacing(4),
    '& button': {
      maxWidth: '326px',
    },
  },
  viewTransactionLink: {
    fontWeight: 800,
  },
}));

const ExamRegistrationsListing = () => {
  const { classes } = useStyles();
  const { t } = useTranslation();
  const history = useHistory<any>();

  const {
    data: transactionHistory,
  } = candidateService.exam.candidate.useGetTransactionHistoryListing({});

  const defaultTab = history?.location?.state?.from === 'TransactionHistoryPages' ? 1 : 0;

  const [selectedTab, setSelectedTab] = useState(defaultTab);
  const onChangeTab = (event: any, newValue: number) => {
    setSelectedTab(newValue);
  };
  // displays 1 tab (RegisteredApplications) if data in Transaction History is not available
  const tabs =
    transactionHistory?.content === undefined || transactionHistory?.content.length === 0
      ? [t('exam->>ViewRegisteredExamsListing.RegisteredApplications')]
      : [
        t('exam->>ViewRegisteredExamsListing.RegisteredApplications'),
        t('exam->>ViewRegisteredExamsListing.TransactionHistory'),
      ];

  return (
    <ContentTemplate type="full" continuous transparent>
      <Box className={classes.table}>
        <Tabs
          value={selectedTab}
          indicatorColor="primary"
          textColor="primary"
          onChange={onChangeTab}
          ariaLabel="Application Status tabs"
          className={classes.tabsHeader}
          // @ts-ignore
          tabs={tabs}
        />
        {selectedTab === 0 && <ExamRegistrationsListingTablesDialog />}
        {selectedTab === 1 && <TransactionHistory />}
      </Box>
    </ContentTemplate>
  );
};

export default ExamRegistrationsListing;
